import { forwardRef, useMemo } from "react";

import { Box, StackProps, Stack, useTheme } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";

export type StorybookDialogPreviewProps = Omit<StackProps, "maxWidth"> & {
  maxWidth?: "xs" | "sm" | "md" | "lg";
};

export const StorybookDialogPreview = forwardRef<HTMLDivElement, StorybookDialogPreviewProps>(
  ({ sx, children, maxWidth: maxWidthProp = "xs", ...rest }, ref) => {
    const theme = useTheme();

    const maxWidth = useMemo(() => {
      switch (maxWidthProp) {
        case "xs":
          return 444;
        case "sm":
          return 600;
        case "md":
          return 900;
        case "lg":
          return 1140;
        default:
          return undefined;
      }
    }, [maxWidthProp]);

    return (
      <Box sx={{ padding: { xs: 2, md: 4 }, backgroundColor: theme.palette.overlay.neutral.moderate }}>
        <Stack
          ref={ref}
          role="dialog"
          {...rest}
          sx={mergeSx(
            {
              maxWidth,
              maxHeight: 600,
              marginInline: "auto",
              backgroundColor: theme.palette.surface.neutral.white,
              borderRadius: 1,
              boxShadow: theme.shadows[8],
            },
            sx
          )}
        >
          {children}
        </Stack>
      </Box>
    );
  }
);

StorybookDialogPreview.displayName = "StorybookDialogPreview";
